<template>
  <div class="app-container">
    <HeaderMenu />
    <router-view />
    <PageFooter />
  </div>
</template>

<script>
import HeaderMenu from './components/HeaderMenu.vue'
import PageFooter from './components/PageFooter.vue'

export default {
  name: 'App',
  components: {
    HeaderMenu,
    PageFooter
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #111; /* Global dark background */
  overflow-x: hidden; /* Prevent horizontal scrollbar */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

/* Ensure router-view takes available space to push footer down */
.app-container > :nth-child(2) {
  flex: 1;
  width: 100%;
}
</style>
